import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { Document } from '@contentful/rich-text-types';

import { PrivacyPageContent } from '../../components/pages/privacy';
import Layout from '../../components/shared/Layout';
import { usePageVistTracker } from '../../hooks/usePageVistTracker';
import { getContentfulClient } from '../../utils/getContentfulClient';

const PRIVACY_POLICY_ENTRY_ID = '3u51or1Z8sVbnrVusmgF55';

type Props = {
  html: string;
};

export default function PrivacyPageContainer(props: Props): React.ReactElement {
  usePageVistTracker();

  return (
    <Layout description="Privacy Policy for Brain.fm" pageTitle="Privacy Policy">
      <PrivacyPageContent html={props.html} />
    </Layout>
  );
}

export async function getServerSideProps(): Promise<{ props: Props }> {
  let html = '';

  try {
    const client = getContentfulClient();
    const privacyPolicyResponse = await client.getEntry<{ body: Document }>(PRIVACY_POLICY_ENTRY_ID);
    html = documentToHtmlString(privacyPolicyResponse.fields.body);
  } catch (error) {
    // TODO - log this to sentry
  }

  return {
    props: {
      html,
    },
  };
}
